/* Seyasha v2 behaviours. Small, dependency-free, safe to load on every page. */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('sy-config') || {}).textContent || '{}'); } catch (e) {}

  /* ---------- hero carousel ---------- */
  function initHero(root) {
    if (root.dataset.syReady) return;
    root.dataset.syReady = '1';
    var track = root.querySelector('.sy-hero__track');
    var slides = $$('.sy-slide', root);
    var dots = $$('[data-sy-dot]', root);
    var i = 0, timer = null, x0 = null;
    function go(n, user) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      slides.forEach(function (s, j) { if (j === i) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1'); });
      dots.forEach(function (d, j) {
        d.classList.toggle('is-on', j === i);
        if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (user) stop();
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true' || slides.length < 2 || reduced || (window.Shopify && Shopify.designMode)) return;
      timer = setInterval(function () { go(i + 1); }, (parseInt(root.dataset.speed, 10) || 5) * 1000);
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.syDot, true); }); });
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), true);
    }, { passive: true });
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.syGo = go;
    start();
  }

  /* ---------- wishlist (saved in this browser) ---------- */
  var WKEY = 'sy-wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(l) { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} }
  function wishPaint() {
    var l = wishGet();
    $$('[data-sy-wish]').forEach(function (b) {
      var on = l.indexOf(b.dataset.syWish) >= 0;
      b.hidden = false;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    var n = document.getElementById('sy-wish-n');
    if (n) { n.textContent = l.length; n.hidden = !l.length; }
  }
  function wishHeaderIcon() {
    if (!cfg.wishlistUrl || document.getElementById('sy-wish-link')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    var a = document.createElement('a');
    a.id = 'sy-wish-link';
    a.href = cfg.wishlistUrl;
    a.className = 'header__icon header__icon--wishlist link focus-inset';
    a.innerHTML = '<span class="svg-wrapper"><svg class="sy-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3S3.5 15.4 3.5 9.2A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 8.5 1.8c0 6.2-8.5 11.1-8.5 11.1Z"/></svg></span>' +
      '<span class="visually-hidden">Wishlist</span><span class="sy-count" id="sy-wish-n" hidden></span>';
    cart.parentNode.insertBefore(a, cart);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), whole = v.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), dec = v.split('.')[1];
    return (fmt || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      return k.indexOf('no_decimals') >= 0 ? Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : whole + '.' + dec;
    });
  }
  function wishPage() {
    var grid = document.querySelector('[data-sy-wishlist]');
    if (!grid) return;
    var empty = document.querySelector('[data-sy-wishlist-empty]');
    var count = document.querySelector('[data-sy-wishlist-count]');
    var l = wishGet();
    if (count) count.textContent = l.length + (l.length === 1 ? ' saved style' : ' saved styles');
    if (!l.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    var root = grid.dataset.root || '/';
    Promise.all(l.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      grid.innerHTML = ps.filter(Boolean).map(function (p) {
        var img = p.featured_image ? '<img src="' + esc(p.featured_image) + (p.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=533" alt="" loading="lazy">' : '';
        return '<div class="sy-card"><div class="sy-card__m"><a class="sy-card__img" style="padding-bottom:111.11%" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<button type="button" class="sy-heart is-on" data-sy-wish="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remove ' + esc(p.title) + ' from wishlist"><svg class="sy-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3S3.5 15.4 3.5 9.2A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 8.5 1.8c0 6.2-8.5 11.1-8.5 11.1Z"/></svg></button></div>' +
          '<div class="sy-card__t"><h3 class="sy-card__name"><a class="full-unstyled-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
          (p.type ? '<span class="sy-card__meta">' + esc(p.type) + '</span>' : '') +
          '<div class="sy-card__price"><div class="price"><span class="price-item price-item--regular">' + money(p.price, grid.dataset.moneyFormat) + '</span></div></div></div></div>';
      }).join('');
    });
  }

  /* ---------- product page: sticky add to cart (phones) ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sy-sticky-atc]');
    var main = document.querySelector('product-info .product-form__submit');
    if (!bar || !main || bar.dataset.syReady) return;
    bar.dataset.syReady = '1';
    var meta = bar.querySelector('[data-sy-sticky-meta]');
    var add = bar.querySelector('[data-sy-sticky-add]');
    function sync() {
      var btn = document.querySelector('product-info .product-form__submit');
      var price = document.querySelector('product-info .price .price-item--last, product-info .price .price-item--regular');
      var onSale = document.querySelector('product-info .price.price--on-sale .price-item--sale');
      var size = '';
      $$('product-info variant-selects fieldset').forEach(function (f) {
        var name = (f.querySelector('legend') || {}).textContent || '';
        var c = f.querySelector('input:checked');
        if (c && /size/i.test(name)) size = c.value;
      });
      if (meta) meta.textContent = ((onSale || price) ? (onSale || price).textContent.trim() : '') + (size ? ' · Size ' + size : '');
      if (btn && add) {
        add.disabled = btn.disabled;
        add.textContent = (btn.querySelector('span') || btn).textContent.trim();
      }
    }
    add.addEventListener('click', function () {
      var btn = document.querySelector('product-info .product-form__submit');
      if (btn && !btn.disabled) btn.click();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        document.documentElement.classList.toggle('sy-has-sticky-atc', !bar.hidden);
      }).observe(main.closest('.product-form__buttons') || main);
    }
    var info = document.querySelector('product-info');
    if (info && 'MutationObserver' in window) new MutationObserver(sync).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('product-info')) setTimeout(sync, 0); });
    sync();
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentNode;
    if (!t || !t.closest) return;
    var el;

    if ((el = t.closest('[data-sy-rail]'))) {
      var rail = document.getElementById(el.getAttribute('aria-controls'));
      if (rail) rail.scrollBy({ left: +el.dataset.syRail * rail.clientWidth * 0.8, behavior: reduced ? 'auto' : 'smooth' });
      return;
    }
    if ((el = t.closest('[data-sy-flip]'))) {
      var card = el.closest('[data-sy-card]');
      var on = card.classList.toggle('is-flipped');
      el.setAttribute('aria-pressed', on);
      return;
    }
    if ((el = t.closest('[data-sy-wish]'))) {
      e.preventDefault();
      var l = wishGet(), h = el.dataset.syWish, k = l.indexOf(h);
      if (k >= 0) l.splice(k, 1); else l.unshift(h);
      wishSet(l.slice(0, 60));
      wishPaint();
      wishPage();
      return;
    }
    if ((el = t.closest('[data-sy-qa-open]'))) {
      $$('[data-sy-card].is-qa-open').forEach(function (c) { c.classList.remove('is-qa-open'); });
      el.closest('[data-sy-card]').classList.add('is-qa-open');
      el.setAttribute('aria-expanded', 'true');
      var first = el.closest('[data-sy-card]').querySelector('[data-sy-qa-variant]:not([disabled])');
      if (first) first.focus();
      return;
    }
    if ((el = t.closest('[data-sy-qa-close]'))) {
      var c2 = el.closest('[data-sy-card]');
      c2.classList.remove('is-qa-open');
      var op = c2.querySelector('[data-sy-qa-open]');
      if (op) { op.setAttribute('aria-expanded', 'false'); op.focus(); }
      return;
    }
    if ((el = t.closest('[data-sy-qa-variant]'))) {
      /* Hand over to Dawn's <product-form>: set the variant id, then submit its form. */
      var pf = el.closest('product-form');
      if (!pf) return;
      var form = pf.querySelector('form');
      var id = form.querySelector('input[name="id"]');
      id.value = el.dataset.syQaVariant;
      id.disabled = false;
      $$('[data-sy-qa-variant]', pf).forEach(function (b) { b.classList.remove('is-busy'); });
      el.classList.add('is-busy');
      if (form.requestSubmit) form.requestSubmit(form.querySelector('[type="submit"]'));
      else form.querySelector('[type="submit"]').click();
      setTimeout(function () {
        el.classList.remove('is-busy');
        if (pf.querySelector('.product-form__error-message-wrapper[hidden]')) el.closest('[data-sy-card]').classList.remove('is-qa-open');
      }, 1600);
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-sy-card].is-qa-open').forEach(function (c) {
      c.classList.remove('is-qa-open');
      var op = c.querySelector('[data-sy-qa-open]');
      if (op) op.setAttribute('aria-expanded', 'false');
    });
  });

  function init() {
    $$('[data-sy-hero]').forEach(initHero);
    wishHeaderIcon();
    if (cfg.wishlistUrl) wishPaint();
    wishPage();
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* theme editor + Dawn ajax re-renders (filters, recommendations) */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-sy-hero]');
    if (hero && hero.syGo) hero.syGo($$('.sy-slide', hero).indexOf(e.target), true);
  });
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      if (pending || !cfg.wishlistUrl) return;
      pending = setTimeout(function () { pending = null; wishPaint(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
